import React from "react";

import {
  ChakraProvider,
  Flex,
  Box,
  Button,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Select,
  UnorderedList,
  ListItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Input,
  ModalFooter,
  useDisclosure
} from "@chakra-ui/react";

import PaypalExpressBtn from "react-paypal-express-checkout";

import CoinbaseCommerceButton from "react-coinbase-commerce";
import "react-coinbase-commerce/dist/coinbase-commerce-button.css";

import WithSubnavigation from "../widgets/NavBar";

function Billing() {
  return (
    <Flex>
      <Table variant="simple">
        <TableCaption>Astroworkers</TableCaption>
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Amount</Th>
            <Th>Description</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Sep 24 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from PAYPAL</Td>
          </Tr>
          <Tr>
            <Td>Sep 25 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from CRYPTO</Td>
          </Tr>
          <Tr>
            <Td>Sep 26 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from PAYPAL</Td>
          </Tr>
          <Tr>
            <Td>Sep 27 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from CRYPTO</Td>
          </Tr>
          <Tr>
            <Td>Sep 28 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from CRYPTO</Td>
          </Tr>
          <Tr>
            <Td>Sep 29 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from PAYPAL</Td>
          </Tr>
          <Tr>
            <Td>Sep 30 2021</Td>
            <Td>$10.00</Td>
            <Td>New deposit from PAYPAL</Td>
          </Tr>
        </Tbody>
      </Table>
    </Flex>
  );
}

function Deposit() {
  const onSuccess = (payment) => {
    // Congratulations, the payment was successful!
    console.log("The payment was successful!", payment);
  };

  const onCancel = (data) => {
    // User pressed 'cancel' or closed the PayPal popup window
    console.log("The payment was cancelled!", data);
  };

  const onError = (err) => {
    // The main PayPal 's script can't be loaded
    console.log("Error!", err);
  };

  // Using sandbox for testing only
  let env = "sandbox";
  // Let's set our currency here
  let currency = "USD";
  // Testing total amount
  let total = 10;

  const client = {
    sandbox:
      "ASKubZJSMqA7_0E2HE3yRKIej3xO92wyK6j6PKSfyyDZljGO23sh_xnOyHH7wIYHR2nPSLZjTZiihw6B"
  };

  return (
    <Flex
      margin={4}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Flex
        padding={4}
        width="300px"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        borderWidth="2px"
        borderRadius="lg"
      >
        <Text fontWeight="bold">Credit/Debit Card Deposits</Text>
        <Select placeholder="25$" width="270px" margin={3}>
          <option value="5$">5$</option>
          <option value="10$">10$</option>
          <option value="15$">15$</option>
          <option value="20$">20$</option>
          {/* <option value="25$">25$</option> */}
          <option value="50$">50$</option>
          <option value="75$">75$</option>
          <option value="100$">100$</option>
          <option value="250$">250$</option>
          <option value="400$">400$</option>
        </Select>
        <PaypalExpressBtn
          env={env}
          client={client}
          currency={currency}
          total={total}
          onError={onError}
          onSuccess={onSuccess}
          onCancel={onCancel}
          style={{ shape: "rect", size: "medium", margin: "1.5rem" }}
        />
      </Flex>
      <Flex
        padding={4}
        marginTop="27px"
        width="300px"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        borderWidth="2px"
        borderRadius="lg"
      >
        <Text fontWeight="bold">Crypto Desposits</Text>
        <Select placeholder="25$" width="270px" margin={3}>
          <option value="5$">5$</option>
          <option value="10$">10$</option>
          <option value="15$">15$</option>
          <option value="20$">20$</option>
          <option value="50$">50$</option>
          <option value="75$">75$</option>
          <option value="100$">100$</option>
          <option value="250$">250$</option>
          <option value="400$">400$</option>
        </Select>
        <CoinbaseCommerceButton
          style={{
            backgroundColor: "#348ceb",
            color: "white",
            borderRadius: "3px",
            width: "130px",
            height: "31px"
          }}
          checkoutId="65ba31ee-a96a-4556-b8b8-21ea1356b5be"
        />
      </Flex>
    </Flex>
  );
}

function Withdrawal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Flex flexDirection="column" alignItems="center">
      <UnorderedList>
        <ListItem>
          Withdraw when you have over $5 in your earned balance.
        </ListItem>
        <ListItem>
          You can not withdraw money from your spendable balance.
        </ListItem>
        <ListItem>Withdrawals are processed within 7 business days.</ListItem>
      </UnorderedList>
      <Button onClick={onOpen} width="210px" colorScheme="blue" margin={4}>
        Request Widthdrawal
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Request Withdrawal</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs isFitted variant="enclosed">
              <TabList mb="1em">
                <Tab>Paypal</Tab>
                <Tab>Cryptocurrency</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <Flex>
                    <Input placeholder="Paypal Email Address" />
                  </Flex>
                </TabPanel>
                <TabPanel>
                  <Input placeholder="Address" />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="blue">Submit Request</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Table variant="simple">
        <TableCaption>Astroworkers</TableCaption>
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Amount</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Sep 24 2021</Td>
            <Td>$10.00</Td>
            <Td>Completed</Td>
          </Tr>
          <Tr>
            <Td>Sep 25 2021</Td>
            <Td>$10.00</Td>
            <Td>Completed</Td>
          </Tr>
          <Tr>
            <Td>Sep 26 2021</Td>
            <Td>$10.00</Td>
            <Td>Completed</Td>
          </Tr>
          <Tr>
            <Td>Sep 27 2021</Td>
            <Td>$10.00</Td>
            <Td>Pending</Td>
          </Tr>
        </Tbody>
      </Table>
    </Flex>
  );
}

export default function Wallet() {
  return (
    <Flex flexDirection="column">
      <WithSubnavigation />

      <Tabs mt="10" variant="enclosed">
        <TabList mt="10">
          <Tab>Deposit</Tab>
          <Tab>Withdrawal</Tab>
          <Tab>Billing</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Deposit />
          </TabPanel>
          <TabPanel>
            <Withdrawal />
          </TabPanel>
          <TabPanel>
            <Billing />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
}
